const normalizeIngredientName = (name) =>
  String(name || '').replace(/^G\s+/i, '')

/**
 * Returns ingredient node IDs sorted by their display name.
 *
 * The ingredient tree uses a leading "G " as a grouping marker. That marker
 * is ignored so those nodes sort by the first meaningful letter in the name.
 *
 * @param {Object[]|Object<string, Object>} nodes Ingredient nodes.
 * @returns {string[]} Sorted node IDs.
 */
const sortIngredientNodeIdsAlphabetically = (nodes) => {
  const nodeList = Array.isArray(nodes) ? nodes : Object.values(nodes || {})

  return nodeList
    .filter((node) => node?._id)
    .map((node, index) => ({ node, index }))
    .sort((first, second) => {
      const nameComparison = normalizeIngredientName(
        first.node.name
      ).localeCompare(normalizeIngredientName(second.node.name), 'nb', {
        sensitivity: 'base'
      })

      return nameComparison || first.index - second.index
    })
    .map(({ node }) => node._id)
}

export default sortIngredientNodeIdsAlphabetically
